import { render, staticRenderFns } from "./ThumbsDown.vue?vue&type=template&id=5666bf70&"
import script from "./ThumbsDown.vue?vue&type=script&setup=true&lang=js&"
export * from "./ThumbsDown.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports